module.exports = __webpack_public_path__ + "img/img02.c4a91e55.jpeg";